window.okeReviewsWidgetOnInit = function () {
    const reviewMain = document.querySelector(".js-okeReviews-reviews-main");
    if (reviewMain) {
        const observerConfig = {
            childList: true
        }
        const observer = new MutationObserver(moveRecommend);
        observer.observe(reviewMain, observerConfig);
        moveRecommend();
    }
}

function moveRecommend() {
    var starRatings = document.querySelectorAll(".okeReviews-review-starRating");
    var reviewerProfile = document.querySelectorAll(".okeReviews-review-reviewer-profile-details");
    if (starRatings.length > 0 && reviewerProfile.length > 0) {
        for (var i = 0; i < starRatings.length; i++) {
            reviewerProfile[i].insertAdjacentElement('beforeend', starRatings[i]);
        }
    }
}
